import styled from "styled-components";

import { OutOfServiceModalStyledProps as Props } from "./OutOfServiceModal.types";

const OutOfServiceModalStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 37.2rem;

  .OutOfServiceModal {
    &__title {
      font-size: 2.4rem;
      line-height: 2.8rem;
      text-align: center;
      padding-bottom: 1.2rem;
      font-weight: 700;
    }

    &__description {
      font-size: 1.6rem;
      line-height: 2.4rem;
      font-weight: 300;
      padding-bottom: 2.4rem;
      text-align: center;
      color: var(--palette-gray-s0-l35);
    }

    &__button,
    &__button-secondary {
      font-size: 1.6rem;
      font-weight: 600;
      width: 100%;
      padding: 1.2rem 2rem !important;
    }

    &__button-secondary {
      background-color: var(--palette-gray-s0-l98) !important;
      color: var(--palette-gray-s0-l35) !important;
      border-color: var(--palette-gray-s0-l35) !important;
    }

    &__buttons {
      display: flex;
      flex-direction: column;
      gap: 1.2rem;
      width: 100%;
    }

    &__svg {
      width: 13.2rem;
      height: 13.2rem;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 2rem;
    }
  }
`;

export default OutOfServiceModalStyled;
